package com.swetdot.swetgram.ui.tasks

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.semantics.progressBarRangeInfo
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import swetgram.shared.generated.resources.shop_title
import com.swetdot.swetgram.domain.DailyTaskDestination
import com.swetdot.swetgram.domain.DailyTaskItem
import com.swetdot.swetgram.domain.DailyTaskKind
import com.swetdot.swetgram.ui.design.Radius
import com.swetdot.swetgram.ui.design.ContentWidth
import com.swetdot.swetgram.ui.design.Motion
import com.swetdot.swetgram.ui.design.Space
import com.swetdot.swetgram.ui.design.SwetEasing
import com.swetdot.swetgram.ui.design.SwetErrorBanner
import com.swetdot.swetgram.ui.design.SwetEmptyState
import com.swetdot.swetgram.ui.design.SwetConfirmDialog
import com.swetdot.swetgram.ui.design.SwetContentPhase
import com.swetdot.swetgram.ui.design.SwetIcon
import com.swetdot.swetgram.ui.design.SwetIcons
import com.swetdot.swetgram.ui.design.SwetLoading
import com.swetdot.swetgram.ui.design.SwetPullToRefresh
import com.swetdot.swetgram.ui.design.SwetScreenTitle
import com.swetdot.swetgram.ui.design.SwetTextButton
import com.swetdot.swetgram.ui.design.SwetStateHost
import com.swetdot.swetgram.ui.design.Sizes
import com.swetdot.swetgram.ui.design.TouchTarget
import com.swetdot.swetgram.ui.design.swetFloatingNavClearance
import com.swetdot.swetgram.ui.design.swetAnimateItem
import com.swetdot.swetgram.ui.design.swetTween
import com.swetdot.swetgram.ui.design.swetContentPhase
import com.swetdot.swetgram.ui.text.resolve
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.tasks_action_enable_steps
import swetgram.shared.generated.resources.tasks_action_open
import swetgram.shared.generated.resources.tasks_action_replace
import swetgram.shared.generated.resources.tasks_all_done
import swetgram.shared.generated.resources.tasks_all_done_body
import swetgram.shared.generated.resources.tasks_completed
import swetgram.shared.generated.resources.tasks_error_load
import swetgram.shared.generated.resources.tasks_like_body
import swetgram.shared.generated.resources.tasks_like_title
import swetgram.shared.generated.resources.tasks_loading
import swetgram.shared.generated.resources.tasks_message_body
import swetgram.shared.generated.resources.tasks_message_title
import swetgram.shared.generated.resources.tasks_post_body
import swetgram.shared.generated.resources.tasks_post_title
import swetgram.shared.generated.resources.tasks_progress_summary
import swetgram.shared.generated.resources.tasks_reply_body
import swetgram.shared.generated.resources.tasks_reply_title
import swetgram.shared.generated.resources.tasks_replacement_used
import swetgram.shared.generated.resources.tasks_retry
import swetgram.shared.generated.resources.tasks_save_body
import swetgram.shared.generated.resources.tasks_save_title
import swetgram.shared.generated.resources.tasks_steps_body
import swetgram.shared.generated.resources.tasks_steps_title
import swetgram.shared.generated.resources.tasks_streak
import swetgram.shared.generated.resources.tasks_title
import swetgram.shared.generated.resources.tasks_unknown_body
import swetgram.shared.generated.resources.tasks_unknown_title
import swetgram.shared.generated.resources.tasks_xp
import swetgram.shared.generated.resources.tasks_level
import swetgram.shared.generated.resources.tasks_steps_consent_body
import swetgram.shared.generated.resources.tasks_steps_consent_continue
import swetgram.shared.generated.resources.tasks_steps_consent_not_now
import swetgram.shared.generated.resources.tasks_steps_consent_title
import swetgram.shared.generated.resources.picso_task_post_title
import swetgram.shared.generated.resources.picso_task_post_body
import swetgram.shared.generated.resources.picso_task_react_title
import swetgram.shared.generated.resources.picso_task_react_body
import swetgram.shared.generated.resources.picso_task_save_title
import swetgram.shared.generated.resources.picso_task_save_body
import swetgram.shared.generated.resources.tasks_steps_opt_in_body
import swetgram.shared.generated.resources.tasks_steps_opt_in_title

@Composable
fun TasksScreen(
    state: TasksUiState,
    onRefresh: () -> Unit,
    onOpenTask: (DailyTaskDestination) -> Unit,
    onReplace: (DailyTaskItem) -> Unit,
    onRequestStepsAccess: () -> Unit,
    onConfirmStepsAccess: () -> Unit,
    onDismissStepsConsent: () -> Unit,
    onDismissError: () -> Unit,
    onOpenShop: () -> Unit = {},
    modifier: Modifier = Modifier,
) {
    val colors = SwetgramThemeTokens.colors
    val navClearance = swetFloatingNavClearance()

    if (state.showStepsConsent) {
        SwetConfirmDialog(
            title = stringResource(Res.string.tasks_steps_consent_title),
            body = stringResource(Res.string.tasks_steps_consent_body),
            confirmText = stringResource(Res.string.tasks_steps_consent_continue),
            cancelText = stringResource(Res.string.tasks_steps_consent_not_now),
            onConfirm = onConfirmStepsAccess,
            onDismiss = onDismissStepsConsent,
            destructive = false,
        )
    }

    Column(modifier.fillMaxSize().background(colors.backgroundDeep)) {
        SwetScreenTitle(stringResource(Res.string.tasks_title))
        state.error?.takeIf { state.today != null }?.let {
            SwetErrorBanner(
                message = it.resolve(),
                retryText = stringResource(Res.string.tasks_retry),
                onRetry = onRefresh,
                onDismiss = onDismissError,
            )
        }

        val today = state.today
        SwetStateHost(
            phase = swetContentPhase(
                hasContent = today != null,
                loadedOnce = state.loadedOnce,
                hasError = state.error != null,
            ),
            modifier = Modifier.fillMaxSize(),
        ) { phase -> when (phase) {
            SwetContentPhase.Loading -> SwetLoading(
                label = stringResource(Res.string.tasks_loading),
                modifier = Modifier.padding(bottom = navClearance),
            )

            SwetContentPhase.Empty -> SwetEmptyState(
                title = stringResource(Res.string.tasks_title),
                body = stringResource(Res.string.tasks_error_load),
                actionText = stringResource(Res.string.tasks_retry),
                onAction = onRefresh,
                modifier = Modifier.padding(bottom = navClearance),
            )

            SwetContentPhase.Error -> SwetEmptyState(
                title = stringResource(Res.string.tasks_title),
                body = state.error?.resolve() ?: stringResource(Res.string.tasks_error_load),
                actionText = stringResource(Res.string.tasks_retry),
                onAction = onRefresh,
                modifier = Modifier.padding(bottom = navClearance),
            )

            SwetContentPhase.Content -> SwetPullToRefresh(
                refreshing = state.refreshing,
                onRefresh = onRefresh,
                modifier = Modifier.fillMaxSize(),
            ) {
                Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.TopCenter) {
                LazyColumn(
                modifier = Modifier.widthIn(max = ContentWidth.tasks).fillMaxSize(),
                contentPadding = PaddingValues(
                    start = Space.screenMargin,
                    end = Space.screenMargin,
                    top = Space.one,
                    bottom = navClearance + Space.two,
                ),
                verticalArrangement = Arrangement.spacedBy(Space.one),
            ) {
                if (today != null) {
                    item(key = "summary") { TasksSummary(state, onOpenShop) }
                    if (state.profile?.stepTasksEnabled == false) {
                        item(key = "steps_opt_in") {
                            StepsOptInCard(onRequestStepsAccess)
                        }
                    }
                    items(today.tasks, key = { it.id }) { task ->
                        TaskCard(
                            modifier = swetAnimateItem(),
                            task = task,
                            canReplace = today.replacementAvailable,
                            replacing = state.replacingTaskId == task.id,
                            syncingSteps = state.syncingSteps && task.kind == DailyTaskKind.STEPS,
                            onOpen = { onOpenTask(task.destination) },
                            onReplace = { onReplace(task) },
                        )
                    }
                    if (today.completedCount == today.totalCount && today.totalCount > 0) {
                        item(key = "complete") { CompletionCard(modifier = swetAnimateItem()) }
                    }
                    if (!today.replacementAvailable) {
                        item(key = "replacement_used") {
                            Text(
                                text = stringResource(Res.string.tasks_replacement_used),
                                style = MaterialTheme.typography.labelMedium,
                                color = colors.textTertiary,
                                modifier = Modifier.fillMaxWidth().padding(vertical = Space.one),
                            )
                        }
                    }
                }
                }
                }
            }
        } }
    }
}

@Composable
private fun StepsOptInCard(onRequestStepsAccess: () -> Unit) {
    val colors = SwetgramThemeTokens.colors
    Surface(
        color = colors.surface,
        shape = RoundedCornerShape(Radius.lg),
        border = BorderStroke(Sizes.borderHairline, colors.border),
        modifier = Modifier.fillMaxWidth(),
    ) {
        Column(Modifier.padding(Space.two)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(
                    Modifier.size(44.dp).clip(CircleShape).background(colors.graphite),
                    contentAlignment = Alignment.Center,
                ) {
                    SwetIcon(
                        icon = SwetIcons.Steps,
                        tint = colors.textPrimary,
                        contentDescription = null,
                        size = Sizes.iconMedium,
                    )
                }
                Spacer(Modifier.width(Space.two))
                Column(Modifier.weight(1f)) {
                    Text(
                        stringResource(Res.string.tasks_steps_opt_in_title),
                        style = MaterialTheme.typography.titleSmall,
                        color = colors.textPrimary,
                    )
                    Spacer(Modifier.height(Space.half))
                    Text(
                        stringResource(Res.string.tasks_steps_opt_in_body),
                        style = MaterialTheme.typography.bodySmall,
                        color = colors.textSecondary,
                    )
                }
            }
            SwetTextButton(
                text = stringResource(Res.string.tasks_action_enable_steps),
                onClick = onRequestStepsAccess,
                modifier = Modifier.align(Alignment.End),
            )
        }
    }
}

@Composable
private fun TasksSummary(
    state: TasksUiState,
    onOpenShop: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    val today = state.today ?: return
    val progress by animateFloatAsState(
        targetValue = if (today.totalCount == 0) 0f else today.completedCount.toFloat() / today.totalCount,
        animationSpec = swetTween(Motion.normal, SwetEasing.enter),
        label = "tasksSummaryProgress",
    )
    Surface(
        color = colors.surface,
        shape = RoundedCornerShape(Radius.lg),
        border = BorderStroke(Sizes.borderHairline, colors.border),
        modifier = Modifier.fillMaxWidth(),
    ) {
        Column(Modifier.padding(Space.two)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text(
                        stringResource(Res.string.tasks_progress_summary, today.completedCount, today.totalCount),
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.SemiBold,
                        color = colors.textPrimary,
                    )
                    Spacer(Modifier.height(Space.half))
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(Space.two),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        state.profile?.let { profile ->
                            Text(
                                stringResource(Res.string.tasks_level, profile.level),
                                style = MaterialTheme.typography.labelMedium,
                                color = colors.textSecondary,
                            )
                            Text(
                                stringResource(Res.string.tasks_streak, profile.currentStreak),
                                style = MaterialTheme.typography.labelMedium,
                                color = colors.textSecondary,
                            )
                            if (profile.streakFreezes > 0) {
                                Text(
                                    "❄️ ${profile.streakFreezes}",
                                    style = MaterialTheme.typography.labelMedium,
                                    fontWeight = FontWeight.Medium,
                                    color = colors.accent,
                                )
                            }
                        }
                    }
                }
                Text(
                    stringResource(Res.string.tasks_xp, today.earnedXp),
                    style = MaterialTheme.typography.labelLarge,
                    fontWeight = FontWeight.Bold,
                    color = colors.textPrimary,
                )
            }
            Spacer(Modifier.height(Space.two))
            LinearProgressIndicator(
                progress = { progress },
                modifier = Modifier.fillMaxWidth().height(4.dp).clip(CircleShape),
                color = colors.accent,
                trackColor = colors.graphite,
                drawStopIndicator = {},
            )
            Spacer(Modifier.height(Space.two))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                state.profile?.let { profile ->
                    Text(
                        text = "💰 ${profile.spendableXp} XP",
                        style = MaterialTheme.typography.labelLarge,
                        fontWeight = FontWeight.Bold,
                        color = colors.accent,
                    )
                } ?: Spacer(Modifier.width(1.dp))

                Surface(
                    onClick = onOpenShop,
                    color = colors.graphite,
                    shape = RoundedCornerShape(Radius.full),
                    border = BorderStroke(Sizes.borderHairline, colors.border),
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = Space.one, vertical = Space.half),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Text(
                            text = "🛍️ " + stringResource(Res.string.shop_title),
                            style = MaterialTheme.typography.labelMedium,
                            fontWeight = FontWeight.SemiBold,
                            color = colors.textPrimary,
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun TaskCard(
    modifier: Modifier = Modifier,
    task: DailyTaskItem,
    canReplace: Boolean,
    replacing: Boolean,
    syncingSteps: Boolean,
    onOpen: () -> Unit,
    onReplace: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    val copy = taskCopy(task.kind)
    val icon = when (task.kind) {
        DailyTaskKind.MESSAGE -> SwetIcons.MessageSquare
        DailyTaskKind.DISCOVER_POST -> SwetIcons.CreateDiscoverPost
        DailyTaskKind.DISCOVER_LIKE -> SwetIcons.Heart
        DailyTaskKind.STEPS -> SwetIcons.Steps
        DailyTaskKind.DISCOVER_SAVE -> SwetIcons.Bookmark
        DailyTaskKind.REPLY -> SwetIcons.Reply
        DailyTaskKind.PICSO_POST -> SwetIcons.ImageIcon
        DailyTaskKind.PICSO_REACT -> SwetIcons.Heart
        DailyTaskKind.PICSO_SAVE -> SwetIcons.Bookmark
        DailyTaskKind.UNKNOWN -> SwetIcons.Check
    }
    val openable = !task.completed && task.destination in setOf(
        DailyTaskDestination.CHATS,
        DailyTaskDestination.DISCOVER,
        DailyTaskDestination.PICSO,
        DailyTaskDestination.STEP_PERMISSION,
    )
    val measurable = taskUsesProgressBar(task.goal)
    val animatedProgress by animateFloatAsState(
        targetValue = task.progressFraction,
        animationSpec = swetTween(Motion.normal, SwetEasing.enter),
        label = "taskProgress",
    )

    Surface(
        color = if (task.completed) colors.card.copy(alpha = 0.72f) else colors.card,
        shape = RoundedCornerShape(Radius.lg),
        border = BorderStroke(Sizes.borderHairline, colors.border),
        modifier = modifier.fillMaxWidth(),
    ) {
        Column(Modifier.padding(Space.one + Space.half)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(
                    Modifier
                        .size(TouchTarget.minimum)
                        .clip(CircleShape)
                        .background(if (task.completed) colors.accent else colors.graphite),
                    contentAlignment = Alignment.Center,
                ) {
                    SwetIcon(
                        icon = if (task.completed) SwetIcons.Check else icon,
                        tint = if (task.completed) colors.onAccent else colors.textPrimary,
                        contentDescription = null,
                        size = Sizes.iconMedium,
                    )
                }
                Spacer(Modifier.width(Space.two))
                Column(Modifier.weight(1f)) {
                    Text(
                        stringResource(copy.first),
                        style = MaterialTheme.typography.titleMedium,
                        color = colors.textPrimary,
                    )
                    Spacer(Modifier.height(Space.half))
                    Text(
                        stringResource(copy.second),
                        style = MaterialTheme.typography.bodySmall,
                        color = colors.textSecondary,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
                Spacer(Modifier.width(Space.one))
                Text(
                    stringResource(Res.string.tasks_xp, task.xpReward),
                    style = MaterialTheme.typography.labelMedium,
                    color = if (task.completed) colors.accent else colors.textSecondary,
                )
            }

            if (measurable) {
                Spacer(Modifier.height(Space.one))
                LinearProgressIndicator(
                    progress = { animatedProgress },
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(4.dp)
                        .clip(CircleShape)
                        .semantics {
                            progressBarRangeInfo = androidx.compose.ui.semantics.ProgressBarRangeInfo(
                                task.progressFraction,
                                0f..1f,
                            )
                        },
                    color = colors.accent,
                    trackColor = colors.graphite,
                    drawStopIndicator = {},
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    if (task.completed) stringResource(Res.string.tasks_completed) else "${task.progress}/${task.goal}",
                    style = MaterialTheme.typography.labelMedium,
                    color = if (task.completed) colors.textPrimary else colors.textTertiary,
                    modifier = Modifier.weight(1f),
                )
                if (canReplace && !task.completed) {
                    SwetTextButton(
                        text = stringResource(Res.string.tasks_action_replace),
                        onClick = onReplace,
                        enabled = !replacing,
                    )
                }
                if (openable) {
                    SwetTextButton(
                        text = stringResource(
                            if (task.destination == DailyTaskDestination.STEP_PERMISSION) {
                                Res.string.tasks_action_enable_steps
                            } else {
                                Res.string.tasks_action_open
                            },
                        ),
                        onClick = onOpen,
                        enabled = !syncingSteps,
                    )
                }
            }
        }
    }
}

internal fun taskUsesProgressBar(goal: Int): Boolean = goal > 1

@Composable
private fun CompletionCard(modifier: Modifier = Modifier) {
    val colors = SwetgramThemeTokens.colors
    Surface(color = colors.surface, shape = RoundedCornerShape(Radius.lg), modifier = modifier.fillMaxWidth()) {
        Column(Modifier.padding(Space.two)) {
            Text(stringResource(Res.string.tasks_all_done), style = MaterialTheme.typography.titleMedium, color = colors.textPrimary)
            Spacer(Modifier.height(Space.half))
            Text(stringResource(Res.string.tasks_all_done_body), style = MaterialTheme.typography.bodySmall, color = colors.textSecondary)
        }
    }
}

@Composable
private fun taskCopy(kind: DailyTaskKind): Pair<StringResource, StringResource> = when (kind) {
    DailyTaskKind.MESSAGE -> Res.string.tasks_message_title to Res.string.tasks_message_body
    DailyTaskKind.DISCOVER_POST -> Res.string.tasks_post_title to Res.string.tasks_post_body
    DailyTaskKind.DISCOVER_LIKE -> Res.string.tasks_like_title to Res.string.tasks_like_body
    DailyTaskKind.STEPS -> Res.string.tasks_steps_title to Res.string.tasks_steps_body
    DailyTaskKind.DISCOVER_SAVE -> Res.string.tasks_save_title to Res.string.tasks_save_body
    DailyTaskKind.REPLY -> Res.string.tasks_reply_title to Res.string.tasks_reply_body
    DailyTaskKind.PICSO_POST -> Res.string.picso_task_post_title to Res.string.picso_task_post_body
    DailyTaskKind.PICSO_REACT -> Res.string.picso_task_react_title to Res.string.picso_task_react_body
    DailyTaskKind.PICSO_SAVE -> Res.string.picso_task_save_title to Res.string.picso_task_save_body
    DailyTaskKind.UNKNOWN -> Res.string.tasks_unknown_title to Res.string.tasks_unknown_body
}
